import React, {useState} from "react";
import "../styles/Inicio.css";
import Galeria from "./Galeria.js";
import Filtros from "./Filtros.js";
import Descripcion from "./Descripcion.js";
import Paginacion from "./Paginacion.js";




//Este componente muestra la pagina principal de la aplicacion
const Inicio = ()=>{

    const [filtros,setFiltros] = useState("Peliculas populares");
    const [pelicula,setPelicula] = useState(null);
    const [page, setPage] = useState(1);

    // El elemento Filtros llamara a aesta funcion cada vez que desee actualizar el estado de los filtros del componente inicio
    const actualizar = (nuevo)=>{
        setFiltros(nuevo);
    }

    
    // El recuadro de descripcion sera controlado por las siguientes funciones
    const esconderDescripcion = ()=>{
        let recuadro = document.querySelector(".descripcion");
        recuadro.classList.add("descripcion-esconder");
    }
    const mostrarDescripcion = ()=>{
        try{
            let recuadro = document.querySelector(".descripcion");
            recuadro.classList.remove("descripcion-esconder");
        }   
        catch(err){
            console.log("Doble ejecucion");
        }
    }
    const seleccionarPelicula = (id,titulo,descripcion)=>{
        setPelicula({id,titulo,descripcion});
        mostrarDescripcion();
    }
    

    return (

        <div className="inicio">
            
            <section className="inicio__galeria">
                <Galeria page={page} language="es-MX" solicitar={filtros} click={seleccionarPelicula} />
            </section>

            <aside className="inicio__asideBar">
                <Filtros llamar={actualizar} />
            </aside>

            <div className="inicio__paginacion">
                <Paginacion setear={setPage} />
            </div>

            {pelicula && 
                <div className="inicio__descripcion">
                    <Descripcion click={esconderDescripcion} titulo={pelicula.titulo} contenido={pelicula.descripcion} />
                </div>
            }
            
        </div>
    );
}


export default Inicio;